import * as XLSX from 'xlsx'

export const exportCSVFile = (data: any, fileName: string, format: string) => {
  const workSheet = XLSX.utils.aoa_to_sheet(data)
  const workBook = { Sheets: { data: workSheet }, SheetNames: ['data'] }
  // Download
  XLSX.writeFile(workBook, `${fileName}.${format}`)
}
